import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { TouchableOpacity, View } from "react-native"
import { RadioButton } from "react-native-paper"

export const CustomRadio = ({ setValue, checked, value, label }) => {
    return (
        <View>
            <TouchableOpacity onPress={() => setValue(value)}>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <RadioButton
                        color={baseColors.orange.dark}
                        onPress={() => setValue(value)}
                        value={value}
                        status={checked ? "checked" : "unchecked"}
                    />
                    <OpenSansText fontSize={16}>{label}</OpenSansText>
                </View>
            </TouchableOpacity>
        </View>
    )
}
